module.exports = __webpack_public_path__ + "img/gamechar_rig_thumb.534dd3b0.jpg";